import { apiClient } from '../utils/apiClient';

/**
 * UC2 product links — a new-product introduction for an EXISTING investor parks a PENDING
 * link server-side; the investor approves or declines it here after signing in (journeys
 * BRD §4 confirm-on-login: no auto-merge, the investor's approval seals the link).
 */
export interface ProductLinkDto {
  id: number;
  /** Who the journey activates under (family redesign); null/absent = the account holder. */
  personName?: string | null;
  introCode?: string;
  productName?: string;
  serviceProviderName?: string;
  status?: string; // PENDING | ACTIVE | DECLINED | IDENTITY_REVIEW
  createdAt?: string;
  confirmedAt?: string;
}

class ProductLinkService {
  private readonly base = '/api/clients/me/product-links';

  /** Pending new-product introductions awaiting the investor's approval. */
  async getPending(): Promise<ProductLinkDto[]> {
    const res = await apiClient.get<ProductLinkDto[]>(`${this.base}/pending`);
    return res.data;
  }

  /** Approve → activates the new product journey (it appears in the journeys list). */
  async approve(id: number): Promise<ProductLinkDto> {
    const res = await apiClient.post<ProductLinkDto>(`${this.base}/${id}/approve`);
    return res.data;
  }

  /** Decline an unexpected introduction. */
  async decline(id: number): Promise<ProductLinkDto> {
    const res = await apiClient.post<ProductLinkDto>(`${this.base}/${id}/decline`);
    return res.data;
  }
}

export const productLinkService = new ProductLinkService();
